import { ref } from "vue";
import { useStore } from "vuex";

import { Tag } from "@/typings/tag";

interface UseAppointmentTagsOptions {
  taggableType: "customer" | "job";
  entityId: number;
  initialTags?: Tag[];
}

export const useAppointmentTags = ({
  taggableType,
  entityId,
  initialTags = []
}: UseAppointmentTagsOptions) => {
  const store = useStore();

  const newTag = ref(Object.assign(new Tag(), { taggable_type: taggableType }));
  const tags = ref<Tag[]>([...initialTags]);
  const showTagMenu = ref(false);
  const showTagModal = ref(false);

  const tagListConfig = {
    editable: false,
    removeable: true,
    clickEmit: "",
    useColorLabels: false
  };

  const toggleTagMenu = () => {
    showTagMenu.value = !showTagMenu.value;
  };

  const toggleNewTagModal = (label: string) => {
    newTag.value.label = label;
    showTagModal.value = !showTagModal.value;
  };

  const handleSaveSuccess = (tag: Tag) => {
    toggleNewTagModal(tag.label);
    handleAddTag(tag);
  };

  const handleAddTag = async (tag: Tag) => {
    const response = await store.dispatch("addTag", {
      tag_id: tag.id,
      [`${taggableType}_id`]: entityId,
      tag_type: taggableType
    });
    tags.value = tags.value.concat([response.data]);
  };

  const handleRemoveTag = async (tag: Tag) => {
    await store.dispatch("removeTag", {
      tag_id: tag.id,
      [`${taggableType}_id`]: entityId,
      tag_type: taggableType
    });
    tags.value = tags.value.filter((t) => t.id !== tag.id);
  };

  const maxTags = window.currentTenant.tags_config[taggableType].max_allowed;

  return {
    newTag,
    tags,
    showTagMenu,
    showTagModal,
    tagListConfig,
    maxTags,
    toggleTagMenu,
    toggleNewTagModal,
    handleAddTag,
    handleRemoveTag,
    handleSaveSuccess
  };
};
